var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9816_34723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7501 18H11.2501C10.5611 18 10.0001 17.439 10.0001 16.75V11H7.25005C6.59305 11 6.25205 10.209 6.70705 9.73201L11.9571 4.23201C12.2401 3.93601 12.7601 3.93601 13.0431 4.23201L18.2931 9.73201C18.7481 10.209 18.4071 11 17.7501 11H15.0001V16.75C15.0001 17.439 14.4391 18 13.7501 18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 24H3.5C1.846 24 0.5 22.654 0.5 21V16C0.5 14.346 1.846 13 3.5 13H5C5.552 13 6 13.448 6 14C6 14.552 5.552 15 5 15H3.5C2.949 15 2.5 15.449 2.5 16V21C2.5 21.551 2.949 22 3.5 22H21.5C22.051 22 22.5 21.551 22.5 21V16C22.5 15.449 22.051 15 21.5 15H20C19.448 15 19 14.552 19 14C19 13.448 19.448 13 20 13H21.5C23.154 13 24.5 14.346 24.5 16V21C24.5 22.654 23.154 24 21.5 24Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9816_34723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/up_arrow.404a61706cb24c7762d5f649b4cb4c4f.svg";
export { ForwardRef as ReactComponent };